"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyObject = void 0;
exports.entries = entries;
exports.mapKeys = mapKeys;
exports.mapValues = mapValues;
exports.merge = merge;
exports.renameKeys = void 0;
const emptyObject = {};
exports.emptyObject = emptyObject;
function entries(item) {
  return Object.entries(item);
}
function mapKeys(obj, callbackFn) {
  return Object.keys(obj).reduce((acc, key) => {
    const newKey = callbackFn(obj[key], key, obj);
    acc[newKey] = obj[key];
    return acc;
  }, {});
}
function mapValues(obj, callbackFn) {
  return Object.keys(obj).reduce((acc, key, i) => {
    acc[key] = callbackFn(obj[key], key, i);
    return acc;
  }, {});
}
const renameKeys = (obj, newKeys) => {
  const objClone = Object.assign({}, obj);
  const transformedObj = Object.keys(objClone).reduce((res, key) => {
    const newKey = newKeys[key] || key;
    res[newKey] = objClone[key];
    return res;
  }, {});
  return transformedObj;
};

/**
 *
 * @param baseObj The base object you want to merge onto or return if condition is not met
 * @param objToMerge The object you want to merge
 * @returns newly merged object
 */
exports.renameKeys = renameKeys;
function merge(baseObj, objToMerge) {
  return Object.assign({}, baseObj, objToMerge !== null && objToMerge !== void 0 ? objToMerge : emptyObject);
}